module.exports = __webpack_public_path__ + "static/media/wenhua-1@2x.a376f29e.png";